/**
 * Container element to allow app to be pushed down when adding banners or content
 * whilst maintaining app layout.
 */
import React from "react";
import { SaleBanner } from '../components/banner/SaleBanner';
import { makeStyles } from '@material-ui/styles';


const useStyles = makeStyles({
  container: {
    position: "relative"
  },
})

const BannerContainer: React.FC<any> = (props: React.PropsWithChildren<any>) => {
  const classes = useStyles();
  return (
    <div>
     <div>
        <SaleBanner />
     </div>
      <div className={classes.container} >
        {props.children}
      </div>
    </div>
  )
}

export default BannerContainer;
